import "./Stage.scss";
import stage1 from "../../../assets/images/image0001333.jpeg";
import stage2 from "../../../assets/images/image0000888.jpeg";
import stage3 from "../../../assets/images/image00010.jpeg";
import stage4 from "../../../assets/images/image0000111.jpeg";
import { useEffect, useRef, useState } from "react";
import Picture from "../../atoms/picture/Picture";
import Balls from "../balls/Balls";
import { useTranslation } from "react-i18next";

const Stage = () => {
  const carouselRef = useRef();
  const [index, setIndex] = useState(0);
  const { t } = useTranslation();
  const stages = [
    {
      title: t("stageTitle1"),
      srcDesktop: stage1,
      srcMob: stage1,
      alt: "Georgi Dimitrov",
    },
    {
      title: t("stageTitle2"),
      srcDesktop: stage2,
      srcMob: stage2,
      alt: "Katarina Ginoska",
    },
    {
      title: t("stageTitle3"),
      srcDesktop: stage3,
      srcMob: stage3,
      alt: "Nadica Petrusevska",
    },
    {
      title: t("stageTitle4"),
      srcDesktop: stage4,
      srcMob: stage4,
      alt: "Jane Ilijeski",
    },
  ];

  useEffect(() => {
    const items = Array.from(carouselRef.current.children);

    const interval = setInterval(() => {
      const currentActive = items[index];
      const nextIndex = items[index + 1] ? index + 1 : 0;
      const nextActive = items[nextIndex];

      currentActive.style.opacity = 0;
      nextActive.style.opacity = 1;
      setIndex(nextIndex);
    }, 6000);

    return () => clearInterval(interval);
  }, [index]);

  return (
    <div className={"mdl-stage"}>
      <div className={"mdl-stage-carousel"} ref={carouselRef}>
        {stages.map((stage, index) => {
          return (
            <div
              className={"mdl-stage-carousel-item"}
              style={{ opacity: index > 0 ? 0 : 1 }}
              key={stage.title}
            >
              <div className={"mdl-stage__left"}>
                <div className={"mdl-stage__left-inner"}>
                  <h1>{stage.title}</h1>
                  <h4>{t("stageSubtitle")}</h4>
                </div>
              </div>
              <div className={"mdl-stage__right"}>
                <div>
                  <Picture
                    srcDesktop={stage.srcDesktop}
                    srcMobile={stage.srcMob}
                    alt={stage.alt}
                  />
                </div>
                <Balls />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Stage;
